export enum NavigationDirections {
	FORWARD = 'forward',
	BACKWARD = 'backward',
}
